<template>
  <div>
    <router-link to="/cms-read"><small>Tous les articles</small></router-link>
    <div v-if="article" class="white-box py-4 px-3">
      <h1>{{article.Titre}}</h1>
      <div class="text-muted">{{formattedDate}}</div>
      <span class="categ">{{article.CategoryName}}</span>
      <p class="article-content" v-html="article.Corps"></p>
    </div>
  </div>
</template>

<script>
  import { getArticle } from "@/utils/cms"
  export default {
    name: "CmsReadSingle",
    data() {
      return {
        article: null
      };
    },
    mounted() {
      this.initData();
    },
    methods: {
      initData() {
        getArticle(this.$route.params.id).then(res => {
          this.article = res;
          console.log("article: ", res);
        });
      }
    },
    computed: {
      formattedDate() {
        if (!this.article) return "";
        const creationDate = new Date(this.article.CreationDate);
        return "Le "
          + creationDate.getDate().toString().padStart(2, "0") + "/"
          + (creationDate.getMonth() + 1).toString().padStart(2, "0") + "/"
          + creationDate.getFullYear() + " à " 
          + creationDate.getHours().toString().padStart(2, "0") + ":"
          + creationDate.getMinutes().toString().padStart(2, "0")
      }
    }
  }
</script>

<style scoped>
  h1 {
    margin-bottom: 0 !important;
  }

  .categ {
    display: inline-block;
    text-align: center;
    padding: 10px;
    background-color: #198754;
    color: white;
    word-break: break-word;
    margin-top: 0.5em;
  }

  .article-content {
    margin-top: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Adherent/CmsReadSingle.vue